import request from '@/utils/request'
// 问卷答案详情接口
export function getAnswer(answerId) {
  return request({
    url: `/feature/questionnaire/getAnswer?answerId=${answerId}`,
    method: 'get',
  })
}
// 确认发送
export function saveOk(data) {
  return request({
    url: `/feature/questionnaire/saveOk`,
    method: 'post',
    data
  })
}